import React from 'react';
import { MenuEntry } from '@europrocurement/flexy-components';

import { publisherIcon, publishersListIcon } from '@europrocurement/l2d-icons';
import { KeycloakRoute, REALM_ADMIN, REALM_COMPTA } from '@europrocurement/l2d-keycloak';
import PublisherDetail from './views/detail/Publisher/PublisherDetail';
import PublishersListing from './views/listing/PublishersListing';
import PublisherRoot from './views/PublisherRoot';
import { PUBLISHERS_LIST, PUBLISHERS_REMINDER_LIST, publishersBasePath } from './constants/paths';
import PublishersRemindersListing from './views/listing/PublishersRemindersListing';
import PublisherReminderDetails from './views/detail/PublisherReminder/PublisherReminderDetails';

const VALID_ROLES = [REALM_ADMIN, REALM_COMPTA];

export const PublisherRouter = {
    path: publishersBasePath,
    element: <PublisherRoot />,
    children: [
        {
            path: 'liste',
            children: [
                {
                    path: '',
                    index: true,
                    element: (
                        <KeycloakRoute roles={VALID_ROLES}>
                            <PublishersListing />
                        </KeycloakRoute>
                    ),
                },
                {
                    path: ':idPublisher',
                    element: (
                        <KeycloakRoute roles={VALID_ROLES}>
                            <PublisherDetail />,
                        </KeycloakRoute>
                    ),
                },
            ],
        },
        {
            path: 'rappels',
            children: [
                {
                    path: '',
                    element: (
                        <KeycloakRoute roles={VALID_ROLES}>
                            <PublishersRemindersListing />,
                        </KeycloakRoute>
                    ),
                },
                {
                    path: ':idPublisherReminder',
                    element: (
                        <KeycloakRoute roles={VALID_ROLES}>
                            <PublisherReminderDetails />,
                        </KeycloakRoute>
                    ),
                },
            ],
        },
    ],
};

export const PublisherMenuEntries: MenuEntry[] = [
    {
        title: `${publisherIcon.displayName}s`,
        icon: publisherIcon,
        role: VALID_ROLES,
        children: [
            {
                title: 'Liste des fournisseurs',
                icon: publishersListIcon,
                href: PUBLISHERS_LIST,
                role: VALID_ROLES,
            },
            {
                title: 'Rappels',
                icon: 'reply-clock',
                href: PUBLISHERS_REMINDER_LIST,
                role: VALID_ROLES,
            },
        ],
    },
];
